// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__x9bU6","mask":"Loading_mask__c-oNA","loading-ring":"Loading_loading-ring__UwL88"};